import {computed, ref} from "vue";

// fullstack's stats.json: {videos, hours} per collection (masterclass, workshop, both) and for the
// whole library ("library" entry, as totals), built once
// from the video index (fullstack server/services/videos/buildVideoStats.js). /sitemaps is
// proxied (dev) or rewritten (Vercel) to fullstack.
const stats = ref(null); // shared: fetched once per page load
const totals = computed(() => stats.value?.library || null);

async function fetchLibraryTotals() {
  try {
    const response = await fetch("/sitemaps/videos/stats.json");
    if (!response.ok) return;
    stats.value = await response.json();
  } catch (error) {
    console.error(`useLibraryTotals: ${error}`);
  }
}

export default function useLibraryTotals() {
  if (!stats.value) fetchLibraryTotals();
  return {totals, stats};
}
